import { z } from "zod";

/**
 * Wallet integration fields shared by Earn and Tokenization widget configs.
 */
export const WalletFeatureFieldsObjectSchema = z.object({
  walletInfo: z.boolean().default(true),
  walletMode: z.enum(["internal", "external"]),
  /**
   * Controls how the widget resolves token and native balances.
   * - "internal": Use the Blockdaemon SDK (default behaviour).
   * - "external": Use balances supplied by the host application via postMessage.
   *   Requires walletMode to also be "external".
   */
  balanceMode: z.enum(["internal", "external"]).default("internal"),
});

/**
 * Subset for widgets that do not support external balance postMessage (e.g. Tokenization).
 */
export const WalletInfoModeFieldsObjectSchema = z.object({
  walletInfo: z.boolean().default(true),
  walletMode: z.enum(["internal", "external"]),
});

export function refineWalletBalanceMode<
  T extends { walletMode: "internal" | "external"; balanceMode: "internal" | "external" },
>(data: T, ctx: z.core.$RefinementCtx<T>): void {
  if (data.balanceMode === "external" && data.walletMode !== "external") {
    ctx.addIssue({
      code: "custom",
      path: ["balanceMode"],
      message:
        'balanceMode: "external" requires walletMode to also be "external". External balances can only be provided when the widget is operating in external wallet mode.',
    });
  }
}
